import React from 'react';
import { connectCurrentRefinements } from 'react-instantsearch-dom';
import { useTranslation } from '~/shared/utils';
import { Button } from '~/shared/components';

export const ClearFiltersButton = connectCurrentRefinements(({ items, refine }) => {
    const { translate } = useTranslation();
    return (
        <Button
            variant="secondary"
            size="md"
            onClick={() => refine(items)}
            disabled={!items.length}
        >
            {translate('commerce.filters.clearAll')}
        </Button>
    );
});
